import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';

import { UpdateBadPressInfoComponent }
  from 'app/entities/monitoring/actual/badpress/badpressinfo/updatebadpressinfo/update-bad-press-info.component';
import { BadPressService } from 'app/entities/monitoring/actual/badpress/bad-press.service';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'bad-press-info',
  providers: [BadPressService],
  templateUrl: './bad-press-info.component.html',
  styleUrls: ['./bad-press-info.component.css']
})

/**
 * Component to display the monitoring bad press data.
 */
export class BadPressInfoComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;

  dialogRef: MdDialogRef<any>;
  badPressInfoData: string;
  badPressInfoLoaded = false;
  // Here -1 value is taken to display the spinned until the data is loaded.
  badPressInfoDataCount: number = -1;
  matchResolutions: ApplicationValue[];

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private badPressInfoService: BadPressService,
    private entityMonitoringService: EntityMonitoringService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.ngOnChanges();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.PANAMA_PAPERS_MATCH_RESOLUTION));
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      this.getBadPressInfoDesc();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getBadPressInfoDesc() {
    this.badPressInfoLoaded = false;
    this.badPressInfoData = '';
    this.entityMonitoringService.getBadPressHistory(this.id).subscribe(response => {
      const list = (response && response.suggestionList) || [];
      this.badPressInfoDataCount = list.filter(r => this.isPositiveResolution(r && r.matchResolution)).length;
      this.badPressInfoLoaded = true;
    }, _err => {
      this.badPressInfoDataCount = 0;
      this.badPressInfoLoaded = true;
    });
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(response => {
        this.warmUpService.setApplicationTypeInLS(response);
        this.matchResolutions = response.values;
        if (this.id) {
          this.getBadPressInfoDesc();
        }
      });
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  getMatchStatus(matchId) {
    if (this.matchResolutions) {
      const match = this.matchResolutions.find(matchResolution => matchResolution.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'Probable';
  }

  isPositiveResolution(matchId): boolean {
    const name = this.getMatchStatus(matchId);
    return /true/i.test(name);
  }

  // Open dialog having text editor to update Monitoring Elaboration text.
  openBadPressInfoUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdateBadPressInfoComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argBadPressDetailsData = this.badPressInfoData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getBadPressInfoDesc();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/badpress/badpressinfo/bad-press-info.component.ts